const initialState = {
  newOrganizationComplianceForm: false,
  contractAgency: null,
  reviewDate: '',
  clearDate: '',
  complianceDataList: [],
};
export default initialState;
